import { render, staticRenderFns } from "./AlertCardComponent.vue?vue&type=template&id=3e5bc932&"
import script from "./AlertCardComponent.vue?vue&type=script&lang=js&"
export * from "./AlertCardComponent.vue?vue&type=script&lang=js&"
import style0 from "./AlertCardComponent.vue?vue&type=style&index=0&id=3e5bc932&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports